import { useIxmUserauthV1OrganizationQueryServiceOrganizationGet } from '@interxfi/api-client/generated/hooks/ixm-userauth-v1-organization-query-service-organization-get';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface OrganizationBreadcrumbProps {
  organizationId: string;
}

export function OrganizationBreadcrumb({ organizationId }: OrganizationBreadcrumbProps) {
  const { data, isPending } = useIxmUserauthV1OrganizationQueryServiceOrganizationGet({ organizationId });

  if (isPending) {
    return <Skeleton charCount={12} />;
  }

  return data?.organization?.data?.profile?.name || `Organization ${getShortenedId(organizationId)}`;
}
